import React from 'react'
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from 'dayjs';
import { TextField } from '@mui/material';
import { DateRangeFilterProps } from '../../types/types';
import { TranslationEnum, usePortalTranslation } from '../../../../providers/TranslationProvider';

const DateRangeFilter = (props: DateRangeFilterProps) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  return (
    <div className="dates-daterange">
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            className="dateEnter"
          >
            <DatePicker
              label={translate(TranslationEnum.common_portal,"From Date")}
              inputFormat="DD-MM-YYYY"
              value={props.startDate}
              maxDate={dayjs()}
              minDate={props.minDate}
              onChange={(value) => {
                if (value) {
                  props.setStartDate(value);
                }
              }}
              renderInput={(props) => (
                <TextField {...props} disabled size="small" />
              )}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={translate(TranslationEnum.common_portal,"To Date")}
              inputFormat="DD-MM-YYYY"
              value={props.endDate}
              maxDate={dayjs()}
              minDate={props.minDate}
              onChange={(value) => {
                if (value) {
                  props.setEndDate(value);
                }
              }}
              renderInput={(props) => (
                <TextField {...props} disabled size="small" />
              )}
            />
          </LocalizationProvider>
        </div>
  )
}

export default DateRangeFilter;